<template>
    <div>
        <div class="seachBox flex">

            <div class="seachList"><span class="name">关键字：</span>
                <a-input placeholder="" class="seachs" v-model="seach.name"/>
            </div>
            <div class="seachList  ">   <a-button type="primary" size="default" class="seachBtn" @click="getList(1)" style="margin-right: 15px">
                查询
            </a-button>
                <a-button size="default" class="seachBtn" @click="resetSeach()">重置</a-button> </div>

            <div class="seachList no"></div>
            <div class="seachList no"></div>
            <div class="seachList no"></div>
        </div>

        <div  >
            <a-button class="top_btn" type="primary" @click="()=>{visible = true; title='添加分类' ;this.editId=''; }" v-has="'btn_add'" >
                添加分类
            </a-button>
            <a-button class="top_btn" type="primary" @click="listOrder()" v-has="'btn_listorder'"> 排序</a-button>
            <a-button class="top_btn" type="primary" :disabled="!hasSelected" :loading="loading"
                      @click="editLanguage('status','1')" v-has="'btn_status_top'">
                显示
            </a-button>
            <a-button class="top_btn" type="primary" :disabled="!hasSelected" :loading="loading"
                      @click="editLanguage('status','0')" v-has="'btn_status_top'">
                隐藏
            </a-button>
            <a-popconfirm
                    title="此操作将永久删除, 是否继续?"
                    ok-text="确定"
                    cancel-text="取消"
                    @confirm="editLanguage('','5')"
                    @cancel="()=>{}"
                    :disabled="!hasSelected"
            >
                <a-button   type="primary" :disabled="!hasSelected" :loading="loading"  v-has="'btn_delete'">
                    删除
                </a-button>
            </a-popconfirm>

            <span  >
        <template v-if="hasSelected">
          {{ `选中 ${selectedRowKeys.length} 项` }}
        </template>
      </span>
        </div>
        <a-table :columns="columns" :data-source="data" :loading="loading" :pagination="pagination" rowKey="id"
                 :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }">
             <span slot="list_order" slot-scope="text, record">
        <a-input   v-model="record.list_order" class="inputs" size="small"/>
      </span>
            <span slot="status" slot-scope="text, record">
         <a-switch   @click="onChange(record)"
                   :checked="text==1?true:false" :disabled="!$_has('btn_status')"/>
      </span>
            <span slot="action" slot-scope="text, record">
                <i v-if="$_hasAll(['btn_edit','btn_delete'])" style="color:#838383">暂无操作权限</i>
        <a @click="(record)=>{visible = true;; title='修改分类'; editId=text.id ; }" v-has="'btn_edit'">编辑  <a-divider type="vertical"/></a>
          <a-popconfirm
                  title="此操作将永久删除, 是否继续?"
                  ok-text="确定"
                  cancel-text="取消"
                  @confirm="confirm([record.id])"
                  @cancel="()=>{}"
          >
   <a v-has="'btn_delete'">删除</a>
  </a-popconfirm>
      </span>
        </a-table>
        <NewForm :visible="visible" :title="title" :editId="editId"
                   @changVisible=" () => { this.visible = false;this.editId=''; this.getList(this.page)}  "/>

    </div>
</template>

<script>
    import API from "./api";
    import moment from 'moment';
    import NewForm from "./components/newForm"
    import {changStatus, removeById,orderList} from "../../../utils/utils"
    const columns = [
        {
            title: "排序",
            dataIndex: "list_order",
            key: "list_order",
            width: "120px",
            scopedSlots: {customRender: "list_order"}
        },
        {
            title: "分类名称",
            dataIndex: "name",
            ellipsis: true,
            key: "name",
        },
        {
            title: "内容类型",
            dataIndex: "type_name",
            ellipsis: true,
            key: "type_name"
        },

        {
            title: "显示状态",
            key: "status",
            dataIndex: "status",
            scopedSlots: {customRender: "status"}
        },
        {
            title: "操作",
            key: "action",
            width: "150px",
            scopedSlots: {customRender: "action"}
        }
    ];
    export default {
        name: "index",
        data() {
            return {
                fieldNames: {label: 'name', value: 'id', children: 'children'},
                visibleImg: false,
                tableImg: "",
                seachList: {
                    category: [],
                    status: []
                },
                page:1,
                seach: {
                    name: "",
                },
                pagination: {
                    pageNo: 1,
                    pageSize: 20, // 默认每页显示数量
                    onShowSizeChange: (pageSize) => (this.pageSize = pageSize), // 改变每页数量时更新显示
                    onChange: this.getList.bind(this), //点击页码事件
                    total: 0, //总条数
                    current: 0,
                    size: "small",
                    showTotal: total => `共 ${total} 条`,
                    showQuickJumper: true
                },
                data: [],
                columns,
                selectedRowKeys: [], // Check here to configure the default column
                loading: true,
                visible: false,
                title: "",
                editId: null
            }
        },
        created() {
            this.$store.state.adminleftnavnum = "/NewConsultant/ConsultantClassifiedManagement"; //设置左侧导航2-2 active
        },
        mounted() {
            this.getList()
        },
        components: {NewForm},
        computed: {
            hasSelected() {
                return this.selectedRowKeys.length > 0;
            },
        },
        methods: {
            confirm(id) {
                removeById(API.service.DELE,id).then(res => {
                    if (res == true) {
                        this.getList(this.page)
                        this.selectedRowKeys = []
                    }
                })
            },
            listOrder() {
                let list_orders = []
                let sortListOrder = {id: "", list_order: ""}
                for (let i = 0; i < this.data.length; i++) {
                    sortListOrder.id = this.data[i].id
                    sortListOrder.list_order = this.data[i].list_order
                    list_orders.push(sortListOrder)
                    sortListOrder = {}
                }

                orderList(API.service.LIST_ORDER, list_orders).then(res => {
                    if (res == true) {
                        this.getList(this.page)
                    }
                })
            },

            onChange(row) {
                let Json = {id: row.id, status: row.status == 0 ? 1 : 0}
                changStatus(API.service.CHANG_STATUS, [Json]).then(res => {
                    if (res == true) {
                        this.getList(this.page)
                    }
                })
            },
            resetSeach() {
                this.loading = true
                this.seach = {
                    name: "",
                }
                this.getList(1)
            },
            getList(page) {
                let seachData = JSON.parse(JSON.stringify(this.seach))
                this.page=page
                API.service.GET_LIST({page: page || 1, ...seachData}).then(res => {
                    this.data = res.data.data.data
                    this.pagination.total = res.data.data.total
                    this.pagination.pageSize = res.data.data.per_page
                    this.pagination.current = res.data.data.current_page
                    this.selectedRowKeys=[]
                    this.loading = false
                })
            },
            onSelectChange(selectedRowKeys) {
                this.selectedRowKeys = selectedRowKeys;
            },
            editLanguage(name, type) {
                if (type == '5') {
                    this.confirm(this.selectedRowKeys)
                }
                let url
                let dataArr = []
                let dataJson = {}
                this.selectedRowKeys.map((item, index) => {
                    dataJson = {}
                    dataJson.id = item;
                    dataJson[name] = type;
                    dataArr.push(dataJson)
                })
                if (name == 'status') {
                    changStatus(API.service.CHANG_STATUS,dataArr).then(res => {
                        if (res == true) {
                            this.getList(this.page)
                            this.selectedRowKeys = []
                        }
                    })
                }
            },
        }
    }
</script>

<style scoped>
    .seachBox .seachList .name {
        width: 70px !important;
    }

    .seachBox .seachList .seachs {
        width: calc(100% - 80px);
    }

    .inputs {
        display: inline-block;
        width: 70px
    }
</style>
